import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PeriscopeWorkflowRuleCriteria } from '@periscopes/general/workflow-rules';
import { usePeriscopeMetadata } from '@hooks';

import { MetadataContainer, MetadataEntry } from '@periscopes/general/metadata';
import { PeriscopeSfWorkflowRuleMetadata, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';

export interface WorkflowRuleMetadataTabProps {
	index: number;
	sonarObjectId: number;
}

export const WorkflowRuleMetadataTab: React.FC<WorkflowRuleMetadataTabProps> = ({ index, sonarObjectId }) => {
	const { loading, metadata } = usePeriscopeMetadata<PeriscopeSfWorkflowRuleMetadata>(
		sonarObjectId,
		SonarObjectType.SalesforceWorkflowRule
	);

	const metadataEntries = useMemo(() => {
		if (!metadata) {
			return [];
		}

		const entries: MetadataEntry[] = [
			{
				label: COPY_SPECIFIC.OBJECT,
				type: 'string',
				value: metadata.parentDisplayName
			},
			{
				label: COPY_SPECIFIC.EVALUATION_CRITERIA,
				type: 'string',
				value: metadata.evaluationCriteria
			},
			{
				label: COPY_SPECIFIC.RULE_CRITERIA,
				type: 'string',
				value: metadata.ruleCriteria
			}
		];

		return entries;
	}, [ metadata ]);

	if (loading) {
		return <LoadingSpinner spinning />;
	}

	return (
		<>
			<MetadataContainer
				entries={ metadataEntries }
				title={ COPY_SPECIFIC.WORKFLOW_RULE_INFORMATION } />
			<PeriscopeWorkflowRuleCriteria
				criteria={ metadata?.criteria ?? [] }
				index={ index }
				isFormula={ Boolean(metadata?.isFormula) } />
		</>
	);
};
